/**
 * ユーザーエージェント判定関数
 *
 * @return {boolean}
 */

'use strict';

// IE判定
var ua = {
  ltIE6:
    typeof window.addEventListener === 'undefined' &&
    typeof document.documentElement.style.maxHeight === 'undefined',
  ltIE7:
    typeof window.addEventListener === 'undefined' &&
    typeof document.querySelectorAll === 'undefined',
  ltIE8:
    typeof window.addEventListener === 'undefined' &&
    typeof document.getElementsByClassName === 'undefined',
  ltIE9: document.uniqueID && typeof window.matchMedia === 'undefined',
};

// ユーザーエージェントを取得して、小文字に変換
var getUA = window.navigator.userAgent.toLowerCase();

if (getUA.indexOf('msie ') > -1 || getUA.indexOf('trident/') > -1) {
  ua.ie11 = true;
}
// iOS, Android判定
if (getUA.indexOf('iphone') !== -1) {
  ua.iphone = true;
} else if (getUA.indexOf('ipad') !== -1) {
  ua.ipad = true;
} else if (getUA.indexOf('android') !== -1 && getUA.indexOf('mobile') !== -1) {
  ua.android = true;
} else if (getUA.indexOf('android') !== -1 && getUA.indexOf('mobile') === -1) {
  ua.androidTab = true;
}

// スマートデバイス判定
if (ua.iphone || ua.ipad || ua.android || ua.androidTab) {
  ua.sd = true;
}

module.exports = ua;
